import { Dialog } from 'vant'

export function getBrowserInfo () {
  const userAgent = navigator.userAgent.toLowerCase()

  // 检查userAgent以确定浏览器类型
  const isEdge = userAgent.includes('edg/')
  const isFirefox = userAgent.includes('firefox/')
  const isChrome = userAgent.includes('chrome/')
  const isSafari = userAgent.includes('safari/') && !isChrome
  const isWebkit = userAgent.includes('applewebkit/')

  // 从userAgent中提取版本号
  let version = (
    (isEdge && userAgent.match(/edg\/([\d.]+)/)?.[1]) ||
    (isFirefox && userAgent.match(/firefox\/([\d.]+)/)?.[1]) ||
    (isChrome && userAgent.match(/chrome\/([\d.]+)/)?.[1]) ||
    (isSafari && userAgent.match(/version\/([\d.]+)/)?.[1]) ||
    ''
  )

  // 根据浏览器类型返回名称
  const name = (
    (isEdge && 'Edge') ||
  (isFirefox && 'Firefox') ||
  (isChrome && 'Chrome') ||
  (isSafari && 'Safari') ||
    (isWebkit && 'Webkit') ||
  '')

  console.log(name, version)
  version = version.split('.')[0]

  let flat

  switch (name) {
    case 'Chrome': flat = version > 51; break
    case 'Edge': flat = version > 79; break
    case 'Firefox': flat = version > 54; break
    case 'Safari': flat = version > 10; break
    case 'Webkit': flat = true; break
    default: flat = false
  }

  return {
    name,
    version,
    flat
  }
}
